module.exports = __webpack_public_path__ + "img/add.0c218d03.png";